module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "block-row-section"
  }, [_c('div', {
    staticClass: "block-row-section__rows"
  }, _vm._l((_vm.props.content), function(row, i) {
    return _c('div', {
      staticClass: "block-row-section__row",
      attrs: {
        "id": row.id
      }
    }, [_c('h2', {
      staticClass: "block-row-section__title",
      domProps: {
        "innerHTML": _vm._s(row.title)
      }
    }), _c('div', {
      staticClass: "block-row-section__content"
    }, [_c('div', {
      staticClass: "block-row-section__content-img",
      style: ({
        backgroundImage: 'url(' + row.img + ')'
      })
    }), _c('div', {
      staticClass: "block-row-section__content-body"
    }, [_c('div', {
      staticClass: "block-row-section__content-body--text",
      domProps: {
        "innerHTML": _vm._s(row.text)
      }
    }), (row.page) ? _c('router-link', {
      staticClass: "block-row-section__content-body--link",
      attrs: {
        "to": row.link_href
      },
      domProps: {
        "innerHTML": _vm._s(row.link_text)
      }
    }) : _vm._e(), (row.new) ? _c('a', {
      staticClass: "block-row-section__content-body--link",
      attrs: {
        "href": row.link_href,
        "target": "_blank"
      },
      domProps: {
        "innerHTML": _vm._s(row.link_text)
      }
    }) : _vm._e()], 1)])])
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7c279d88","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/block/block-row-section/block-row-section.pug
// module id = 1132
// module chunks = 1